import { Menu, type MenuMultiSelectGroupProps, Text } from "@overmap-ai/blocks"
import type { IssueTypePriority, Stored } from "@overmap-ai/common"
import { memo } from "react"

import { IssuePriorityIcon } from "../Icons/IssuePriorityIcon"
import { MultiSelectItemTemplate, SelectAllItemTemplate } from "../MenuGroups/constants"

export interface IssuePriorityMultiSelectGroupProps extends MenuMultiSelectGroupProps<Stored<IssueTypePriority>> {
	priorities: Stored<IssueTypePriority>[]
}

export const IssuePriorityMultiSelectGroup = memo<IssuePriorityMultiSelectGroupProps>((props) => {
	const { ref, priorities, ...rest } = props

	return (
		<Menu.MultiSelectGroup ref={ref} {...rest}>
			<SelectAllItemTemplate>Select all</SelectAllItemTemplate>
			{priorities.map((priority) => (
				<MultiSelectItemTemplate<Stored<IssueTypePriority>> key={priority.uuid} value={priority}>
					<IssuePriorityIcon priority={priority.uuid} />
					<Text className="truncate">{priority.name}</Text>
				</MultiSelectItemTemplate>
			))}
		</Menu.MultiSelectGroup>
	)
})
IssuePriorityMultiSelectGroup.displayName = "IssuePriorityMultiSelectGroup"
